import React, { useEffect, useMemo, useState } from "react";
import { Grid, Box, Typography, Checkbox, FormControlLabel, Divider } from "@mui/material";
import InputField from "../FormFields/inputField";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import NumberInput from "../FormFields/numberInput";
import "./style.css";
import { fetchAllCountryCode, fetchPriceByCalendar } from "../Services/Organisation.service";
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { useTranslation } from "react-i18next";
interface InfoFormProps {
  formField: {
    firstName: { name: string; label: string };
    lastName: { name: string; label: string };
    email: { name: string; label: string };
    phoneNumber: { name: string; label: string };
  };
  values: any;
  setFieldValue: any;
  formValues: any;
  organisationid: string;
  calendarObject: any;
  setNavigationDirection: any;
  navigationDirection: any
}

const InfoForm: React.FC<InfoFormProps> = (props) => {
  // console.log("props", props);
  const {
    formField: { firstName, lastName, phoneNumber, email }, setFieldValue
  } = props;
  const [bookingMemberTypes, setBookingMemberTypes] = useState([]);
  const [countryCode, setCountryCode] = useState([]);
  const [defaultCountryCode, setDefaultCountryCode] = useState("us");
  const { t } = useTranslation();
  useEffect(() => {
    if (props?.values?.calendarid) {
      fetchBookingMemberTypes();
    }
  }, [props?.values]);

  useEffect(() => {
    fetchTopCountryCode();
  }, []);

  useEffect(() => {
    fetch(`https://ipinfo.io?token=${process.env.REACT_APP_IPIINFO}`, { method: "GET" })
      .then(async (res) => {
        const response = await res.json();
        const country = response.country.toLowerCase();
        setDefaultCountryCode(country);
      })
      .catch(error => {
        console.error('Error fetching IP info:', error);
      });
  }, []);

  const fetchBookingMemberTypes = async () => {
    try {
      const response = await fetchPriceByCalendar(props?.values?.calendarid);
      if (response) {
        setFieldValue("bookingMemberTypesList", response?.price?.map((obj: any) => { return {id: obj.bookingmembertypeid, label: obj.bookingmembertype}}))
        setBookingMemberTypes(response?.price);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTopCountryCode = async () => {
    try {
      const response = await fetchAllCountryCode();
      if (response && response.data) {
        setCountryCode(
          response.data
            .sort((a: any, b: any) => a.sort_order - b.sort_order)
            .map((ob: any) => ob.countrycode)
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const totalTickets = useMemo(() => {
    // Ensure that bookingMemberTypes is available and is an object before attempting to reduce
    const bookingMemberTypes = props.formValues?.bookingMemberTypes;
    return Object.keys(bookingMemberTypes || {}).reduce((total, key) => {
      return total + (bookingMemberTypes[key] || 0);
    }, 0);
  }, [props.formValues?.bookingMemberTypes]);

  const hasPositiveBookingType = props.formValues?.bookingMemberTypes &&
  Object.values<number>(props.formValues?.bookingMemberTypes as Record<string, number>).some(value => value > 0);

  return (
    <React.Fragment>
      {/* <div className="inner">
        <div className="remaining-text">
          <div className="__e78df ember-view">
            <ul>
              <li>
                {t(`All tickets include General Admission to`)}{" "}
                <a
                  href="https://curacao-sea-aquarium.com/experiences/curacao-sea-aquarium/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Curaçao Sea Aquarium
                </a>
                !
              </li>
              <li>
                {t(
                  "Non-participating observers will need to purchase General Admission to Curaçao Sea Aquariume separately."
                )}
              </li>
              <li>{t("Babies up to 1 year of age are free of charge.")}</li>
              <li>
                {t(
                  "Each guest younger than 8 years needs to be accompanied by a full paying adult."
                )}
              </li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className="tickets-container">
        <h1 className="ticket-options-title">{t("Ticket Options")}</h1>
        <span className="ticket-options-info">
          💡 Pro Tip: Please read the description for every ticket type before you make payment.
        </span>
        {!!bookingMemberTypes?.length &&
          bookingMemberTypes?.map((obj: any) => {
            return (
              <div className="tickerWrap" key={obj?.bookingmembertypeid}>
                <div className="ticket-text-section">
                  <div className="ticket-text">
                    {obj?.bookingmembertype} (${obj?.unitprice} per ticket)
                  </div>
                  <span className="ticket-text-caption">
                    {obj?.bookingbusinessrule}
                  </span>
                </div>
                <NumberInput
                  name={obj?.bookingmembertypeid}
                  setFieldValue={props.setFieldValue}
                  formValues={props.formValues}
                  priceObject={obj}
                  bookingMemberTypes={bookingMemberTypes}
                />
              </div>
            );
          })}
      </div>
      <Divider />
      <Box display={"flex"} justifyContent={"space-between"} padding={"1.0rem 1.75rem" }>
          <Typography>Total Tickets</Typography>
          <Typography>{totalTickets}</Typography>
      </Box>
      <Divider />
      {
        
      <div className="contectwrapper">
        <h6 className="form-title">{t("Contact Information")}</h6>
        <Grid container spacing={4} sx={{marginBottom: "1.8rem"}}>
          <Grid item xs={12} sm={6}>
            <InputField
              
              name={firstName.name}
              label={firstName.label}
              fullWidth
              className="inputField"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputField
              
              name={lastName.name}
              label={lastName.label}
              fullWidth
              className="inputField"
            />
          </Grid>
          <Grid item xs={12} sm={6}>

            {countryCode.length > 0 && (
              <PhoneInput
                country={defaultCountryCode}
                alwaysDefaultMask={false}
                value={props.formValues.phoneNumber}
                enableSearch
                preferredCountries={countryCode?.sort((a, b) => a - b)}
                // containerClass="inputField"
                inputStyle={{height: "42px", background: "transparent"}}
                onChange={(phone: any, data: any, e: any, formV: any) => { props.setFieldValue(phoneNumber.name, formV) }}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputField  name={email.name} label={email.label} fullWidth className="inputField" />
          </Grid>
        </Grid>

        <Divider sx={{marginBottom: "1.8rem"}}/>
      </div>
      }
    </React.Fragment>
  );
};

export default InfoForm;
